import React from 'react';
import { Skeleton, Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled, { keyframes } from 'styled-components';

const Divider = styled.div`
  position: relative;
  display: flex;
  white-space: nowrap;
  flex-wrap: nowrap;
  align-items: center;
  padding: 8px 0;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  
  &:before, &:after {
    border-top: 1px rgba(255, 255, 255, 0.1) solid;
    content: "";
  }
  
  &:after {
    width 100%;
    margin-left: 10px
  }
  
  &:before {
    width: 20px;
    margin-right: 10px
  }
`;

export default Divider;
